<template>
  <b-nav-item-dropdown
    v-if="userData"
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name text-body font-weight-bolder mb-0">
          {{ userData.fullName }}
        </p>
        <small class="user-status text-body">{{ userData.role }}</small>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.fullName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push('/users')"
    >
      <feather-icon
        size="16"
        icon="UnlockIcon"
        class="mr-50"
      />
      <span>Access & Security</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push({name: 'settings-users'})"
    >
      <feather-icon
        size="16"
        icon="DatabaseIcon"
        class="mr-50"
      />
      <span>Data Source</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push('/campaign-labelling')"
    >
      <feather-icon
        size="16"
        icon="TagIcon"
        class="mr-50"
      />
      <span>Campaign Labelling</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      disabled
      @click="$router.push('/onboarding-brand-info')"
    >
      <feather-icon
        size="16"
        icon="InfoIcon"
        class="mr-50"
      />
      <span>Onboarding</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import { avatarText } from '@core/utils/filter'
import { Auth, Hub } from 'aws-amplify'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
  methods: {
    async logout() {
      try {
        await Auth.signOut()

        // localStorage.removeItem('userData')
        // localStorage.removeItem('authState')
        this.$store.commit('auth/updateIdToken', undefined)
        this.$store.commit('auth/updateState', undefined)
        this.$store.commit('auth/updateUserDataKey', undefined)
        //this.$filter.methods.resetStates()
        // Reset ability
        this.$ability.update(initialAbility)
        // // Redirect to login page
        Hub.dispatch('UI Auth', {
          event: 'AuthStateChange',
          message: 'signedout',
        })
        try {
          await this.$store.dispatch('resetAllStore')
          localStorage.clear()
          await this.$router.push({ name: 'auth-login' })
        } catch (e) {
          console.log(e)
          await this.$router.push({ name: 'auth-login' })
        }
      } catch (error) {
        console.log('error signing out: ', error)
      }
    },
  },
}
</script>
<style lang="scss">
.dropdown-menu {
  min-width: 200px !important;
}
</style>

